import React, { useState } from "react";
import axios from "axios";
import Header from "../Components/Header";
import { Link, useNavigate } from "react-router-dom";

function Login({ darkMode, setDarkMode, isLoggedIn, logout }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const API = process.env.REACT_APP_API_URL;

  const handleLogin = async () => {
    if (!email || !password) {
      alert("Please enter email and password");
      return;
    }
    try {
      setLoading(true);

      const res = await axios.post(`${API}/api/auth/login`, {
        email,
        password
      });

      localStorage.setItem("token", res.data.token);
      navigate("/dashboard");

    } catch (err) {
      alert(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header
        title="My App"
        darkMode={darkMode}
        setDarkMode={setDarkMode}
        isLoggedIn={isLoggedIn}
        logout={logout}
      />

      <div
        style={{
          minHeight: "100vh",
          background: darkMode ? "#121212" : "#f4f6f8",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div
          style={{
            background: darkMode ? "#1e1e1e" : "#fff",
            color: darkMode ? "#fff" : "#000",
            padding: "30px",
            width: "100%",
            maxWidth: "400px",
            borderRadius: "10px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
          }}
        >
          <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
            Login
          </h2>

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              marginBottom: "15px",
              borderRadius: "5px",
              border: "1px solid #ccc"
            }}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              marginBottom: "20px",
              borderRadius: "5px",
              border: "1px solid #ccc"
            }}
          />

          <button
            disabled={loading}
            onClick={handleLogin}
            style={{
              width: "100%",
              padding: "10px",
              background: "blue",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer"
            }}
            
          >
            {loading ? "Logging in..." : "Login"}
          </button>

          <p
            style={{
              marginTop: "15px",
              textAlign: "center",
              fontSize: "14px"
            }}
          >
            Don't have an account?{" "}
            <Link to="/register" style={{ color: "blue" }}>
              Register here
            </Link>
          </p>
        </div>
      </div>
    </>
  );
}

export default Login;